import React from 'react'

export default props => (
	<button type={'button'} className={`btn btn-flat ${props.small ? 'btn-xs' : ''} btn-${props.type}`}
		title={props.title}
		onClick={props.event} disabled={props.disabled}
		style={{ visibility: props.visible ? 'visible' : 'collapse', marginTop: props.marginTop }}>
		<i className={props.icon}></i>
	</button>
)

/*
primary
secondary
success
danger
warning
info
light
dark
link
*/
